/* ==========================================================================
   Деми · чекмедже за количката

   Какво прави:
     · прихваща ВСЯКА форма към /cart/add (продуктова страница и картите
       в каталога) и добавя без презареждане
     · отваря панела при клик върху иконата в хедъра и след добавяне
     · брояч, премахване, обновяване на брояча в хедъра
     · грешки на български в самия панел

   Как се пре-рендира:
     НЕ се смята нищо на ръка. И /cart/add.js, и /cart/change.js връщат
     готовия HTML на секцията `demi-cart-drawer` (поле `sections`), от него
     се взима само вътрешността на [data-cd-contents] и броят от
     data-cd-count. Един-единствен източник на маркировката — Liquid.

   Отказоустойчивост:
     · при всяка грешка панелът се затваря коректно и скролът се отключва;
     · ако този файл изобщо не се вдигне, коренът остава `hidden`, иконата
       в хедъра си е връзка към /cart, а „Към плащане“ е submit на форма —
       нищо не остава невидимо или заключено.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('demi-cart-drawer');
  if (!root || !window.fetch) return;

  var panel = root.querySelector('[data-cd-panel]');
  var scrim = root.querySelector('[data-cd-scrim]');
  var contents = root.querySelector('[data-cd-contents]');
  var errBox = root.querySelector('[data-cd-err]');
  if (!panel || !contents) return;

  var SECTION = 'demi-cart-drawer';
  var opener = null;      /* елементът, върху който се връща фокусът */
  var isOpen = false;
  var busy = false;
  var closeTimer = null;
  var typeTimer = null;
  var lastSync = 0;      /* кога последно е приложен пресен HTML от сървъра */

  var MSG = {
    net: 'Няма връзка със сървъра. Проверете интернета и опитайте пак.',
    stock: 'Няма толкова налични бройки. Количеството е върнато на възможното.',
    gone: 'Продуктът вече не е наличен.',
    generic: 'Нещо не се получи. Опитайте отново след малко.'
  };

  /* ---------------------------------------------------------------- скрол --
     Заключва се ЛОКАЛНО: клас върху <html> + запомнена позиция в data-cd-y.
     Нула глобални browser API (history.scrollRestoration и подобни остават
     недокоснати — веднъж вече счупиха връщането назад).
     lock/unlock са идемпотентни, а unlock се вика и на pagehide, за да не
     може страницата да остане заключена при каквото и да е излизане. */
  function lock() {
    var h = document.documentElement;
    if (h.classList.contains('demi-cd-lock')) return;
    var y = window.pageYOffset || h.scrollTop || 0;
    h.setAttribute('data-cd-y', String(y));
    document.body.style.top = -y + 'px';
    h.classList.add('demi-cd-lock');
  }

  function unlock() {
    var h = document.documentElement;
    if (!h.classList.contains('demi-cd-lock')) return;
    var y = parseInt(h.getAttribute('data-cd-y'), 10) || 0;
    h.classList.remove('demi-cd-lock');
    h.removeAttribute('data-cd-y');
    document.body.style.top = '';
    window.scrollTo(0, y);
  }

  window.addEventListener('pagehide', unlock);
  window.addEventListener('pageshow', function () {
    /* връщане назад от bfcache: ако по някаква причина е останало заключено */
    if (!isOpen) unlock();
  });

  /* --------------------------------------------------------------- фокус -- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function trap(e) {
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) { e.preventDefault(); panel.focus(); return; }
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  /* ------------------------------------------------------- отваряне/затваряне -- */
  function open(trigger) {
    if (trigger) opener = trigger;
    clearTimeout(closeTimer);
    if (isOpen) { refresh(); return; }
    isOpen = true;
    root.hidden = false;
    lock();
    /* Принудителен reflow вместо requestAnimationFrame. rAF се ПАУЗИРА в скрит
       таб и в bfcache — тогава класът `is-open` никога не се слага и панелът
       остава изтеглен извън екрана, без да личи, че е „отворен“. Видяно наживо
       в теста. Четенето на offsetHeight фиксира началното състояние на прехода
       синхронно и работи независимо от кадрите. */
    void root.offsetHeight;
    root.classList.add('is-open');
    var target = panel.querySelector('[data-cd-close]') || panel;
    try { target.focus(); } catch (err) { /* без значение */ }
    refresh();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    hideErr();
    unlock();
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      if (!isOpen) root.hidden = true;
    }, 220);
    returnFocus();
  }

  /* Връщане на фокуса. Опорният елемент невинаги може да го поеме: бутонът
     „Добави в количката“ в продуктовата карта е display:none, докато мишката
     не е върху картата, а display:none елемент не се фокусира. Тогава фокусът
     би паднал в началото на документа — затова резервата е иконата в хедъра,
     която е логичното място, откъдето чекмеджето се отваря пак. */
  function returnFocus() {
    if (opener && document.contains(opener)) {
      try { opener.focus(); } catch (err) { /* без значение */ }
    }
    opener = null;
    var a = document.activeElement;
    if (a && a !== document.body && !panel.contains(a)) return;
    var icon = document.querySelector('.hd__cart');
    if (icon) { try { icon.focus(); } catch (err) { /* без значение */ } }
  }

  scrim && scrim.addEventListener('click', close);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    trap(e);
  });

  /* --------------------------------------------------------------- грешки -- */
  function showErr(text) {
    if (!errBox) return;
    errBox.textContent = text;
    errBox.hidden = false;
  }
  function hideErr() {
    if (!errBox) return;
    errBox.hidden = true;
    errBox.textContent = '';
  }

  /* ------------------------------------------------------------- рендиране -- */
  function syncCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-demi-count]'), function (el) {
      el.textContent = String(n);
      el.classList.toggle('is-on', n > 0);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.hd__cart'), function (a) {
      a.setAttribute('aria-label', 'Количка, ' + n + ' продукта');
    });
  }

  function apply(html) {
    var doc;
    try {
      doc = new DOMParser().parseFromString(html, 'text/html');
    } catch (err) { return false; }
    var newRoot = doc.querySelector('[data-cd-root]');
    if (!newRoot) return false;
    var newContents = newRoot.querySelector('[data-cd-contents]');
    if (!newContents) return false;

    /* подменя се само ако наистина има разлика — иначе всяко обновяване би
       изхвърлило фокуса от полето, в което човекът пише */
    if (newContents.innerHTML !== contents.innerHTML) {
      contents.innerHTML = newContents.innerHTML;
    }
    lastSync = Date.now();
    var n = parseInt(newRoot.getAttribute('data-cd-count'), 10);
    if (!isNaN(n)) {
      root.setAttribute('data-cd-count', String(n));
      syncCount(n);
    }
    return true;
  }

  function sectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  /* Тихо обновяване: количката може да е сменена в друг таб. Пропуска се,
     ако току-що е приложен пресен HTML — иначе всяко добавяне праща втора
     излишна заявка веднага след първата. */
  function refresh(force) {
    if (!force && Date.now() - lastSync < 1500) return;
    var url = window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'sections=' + SECTION;
    fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data && data[SECTION]) apply(data[SECTION]); })
      .catch(function () { /* тихо: панелът вече показва последното известно */ });
  }

  /* --------------------------------------------------------------- заявки --
     Заявките се сериализират с флаг: два бързи клика по „+“ иначе могат да
     се върнат в обратен ред и панелът да покаже стара бройка. */
  function change(key, qty, row) {
    if (busy) return;
    busy = true;
    hideErr();
    if (row) row.setAttribute('aria-busy', 'true');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        sections: SECTION,
        sections_url: sectionsUrl()
      })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          showErr(res.status === 422 ? MSG.stock : MSG.generic);
          refresh(true);
          return;
        }
        if (res.data.sections && res.data.sections[SECTION]) {
          apply(res.data.sections[SECTION]);
        } else {
          refresh();
        }
      })
      .catch(function () { showErr(MSG.net); })
      .then(function () {
        busy = false;
        if (row && document.contains(row)) row.removeAttribute('aria-busy');
      });
  }

  /* ------------------------------------------------ брояч, премахване -- */
  contents.addEventListener('click', function (e) {
    var row = e.target.closest('[data-cd-row]');
    if (!row) return;
    var key = row.getAttribute('data-cd-key');
    if (!key) return;

    if (e.target.closest('[data-cd-remove]')) {
      e.preventDefault();
      change(key, 0, row);
      return;
    }

    var step = e.target.closest('[data-cd-step]');
    if (!step) return;
    e.preventDefault();
    var input = row.querySelector('[data-cd-qty]');
    var cur = input ? parseInt(input.value, 10) : NaN;
    if (isNaN(cur)) cur = 1;
    var next = cur + parseInt(step.getAttribute('data-cd-step'), 10);
    if (next < 1) return;
    change(key, next, row);
  });

  contents.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cd-qty]')) return;
    var row = e.target.closest('[data-cd-row]');
    if (!row) return;
    var key = row.getAttribute('data-cd-key');
    clearTimeout(typeTimer);
    typeTimer = setTimeout(function () {
      var v = parseInt(e.target.value, 10);
      if (isNaN(v) || v < 0) { refresh(true); return; }
      change(key, v, row);
    }, 500);
  });

  /* --------------------------------------------- иконата на количката -- */
  document.addEventListener('click', function (e) {
    var hit = e.target.closest('.hd__cart');
    if (!hit) return;
    /* Ctrl/Cmd/среден клик — оставяме браузъра да си отвори /cart в нов таб */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    open(hit);
  });

  Array.prototype.forEach.call(document.querySelectorAll('.hd__cart'), function (a) {
    a.setAttribute('aria-haspopup', 'dialog');
    a.setAttribute('aria-controls', 'demi-cart-drawer');
  });

  /* ------------------------------------------- прихващане на формите -- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    if (form.hasAttribute('data-cd-skip')) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    hideErr();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Добавя се…';
    }

    function restore() {
      if (!btn) return;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
    }

    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', sectionsUrl());

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: fd
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
      })
      .then(function (res) {
        restore();
        var back = btn || document.querySelector('.hd__cart');
        if (!res.ok) {
          /* панелът се отваря и при грешка — съобщението трябва да се види */
          open(back);
          showErr(res.status === 422 ? MSG.stock : (res.status === 404 ? MSG.gone : MSG.generic));
          refresh(true);
          return;
        }
        var html = res.data.sections && res.data.sections[SECTION];
        if (html) apply(html);
        open(back);
        if (!html) refresh(true);
      })
      .catch(function () {
        restore();
        open(btn || document.querySelector('.hd__cart'));
        showErr(MSG.net);
      });
  });

  /* Стартова синхронизация на брояча: страницата може да е дошла от кеш. */
  syncCount(parseInt(root.getAttribute('data-cd-count'), 10) || 0);
})();
